<div *ngIf="open?.value">

  <div class="closeable-container row row-dark" #container>
    <div class="container-fluid">
      <div class="col-xs-12">

        <button class="close"
                title="Close"
                i18n-title="@@communication-centre.closeable-container.close"
                type="button"
                (click)="close()">
          <i class="fa-regular fa-xmark"></i>
        </button>

      </div>

      <div class="container container-hack">
        <ng-container [ngTemplateOutlet]="contentTemplate"></ng-container>
      </div>

    </div>
  </div>
</div>
